<template>
  <div class="row">
    <div class="col-lg-12">
      <h1 class="page-header">Grupos</h1>
      <div class="row">
        <div class="col-xs-12 col-sm-12">
          <list
            ref="vuetable"
            :show-empty="true"
            title="Listagem de Grupos"
            :api-url="apiUrl"
            report-title="Grupos"
            :fields="fields"
            :initial-page="pagina"
            :appendParams="filtros"
            :pageCollection="'grupos'"
          >
            <template slot="filters">
              <div class="collapse" id="filtros">
                <div class="col-sm-4">
                  <label class="custom-font" for="nome_filter">Nome</label>
                  <input
                    type="text"
                    v-model="nome"
                    class="form-control"
                    name="nome_filter"
                  />
                </div>
                <div class="col-xs-12">
                  <button
                    @click="consultar()"
                    class="btn btn-default margem-topo"
                    name="btnFiltrar"
                  >
                    <font-awesome-icon :icon="'filter'"></font-awesome-icon>
                    Filtrar
                  </button>
                  <button
                    @click="limpar()"
                    class="btn btn-default margem-topo"
                    name="btnLimpar"
                  >
                    <font-awesome-icon :icon="'eraser'"></font-awesome-icon>
                    Limpar Filtros
                  </button>
                </div>
              </div>
            </template>
            <template slot="actions">
              <router-link
                class="btn btn-default"
                :to="{ name: 'user_material_grupo_save' }"
              >
                <font-awesome-icon :icon="'plus'"></font-awesome-icon> Adicionar
              </router-link>
              <button
                class="btn btn-default"
                data-toggle="collapse"
                data-target="#filtros"
              >
                <font-awesome-icon :icon="'filter'"></font-awesome-icon> Filtros
              </button>
            </template>
            <template slot="rowrender" slot-scope="props">
              <div class="">
                <button
                  title="Excluir"
                  class="btn btn-danger"
                  @click="excluir(props.rowData)"
                >
                  <font-awesome-icon :icon="'trash'"></font-awesome-icon>
                </button>
              </div>
            </template>
          </list>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-font {
  font-size: 16px;
  color: #00615c;
}
</style>

<script>
import list from '@/components/common/DataTable'
import { request } from '../../../../request'
export default {
  name: 'mp-grupos',
  inject: ["showConfirm"],
  data() {
    return {
      apiUrl: 'material/grupo',
      fields: [
        {
          name: 'nome',
          title: 'Nome',
          sortField: 'nome',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-3',
          dataClass: 'text-center'
        }
      ]
    }
  },
  components: {
    list
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  methods: {
    excluir(data) {
      const me = this
      var config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          request
            .delete(this.apiUrl + '/' + data.codigo)
            .then(resp => {
              me.consultar()
              me.$toastr.s('Item removido com sucesso')
            })
            .catch(error => {
              me.$toastr.e(error.response.data)
            })
        }
      }
      this.showConfirm(
        'Deseja realmente deletar este item?',
        config
      )
    },
    consultar() {
      this.$refs.vuetable.refresh()
    },
    limpar() {
      this.nome = ''
      this.$refs.vuetable.refresh()
    },
    resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'grupos',
        value: 1
      })
    }
  },
  computed: {
    filtros() {
      const { nome } = this
      return {
        nome
      }
    },
    pagina: {
      get() {
        const { grupos } = this.$store.state.vuetableState
        const { pagina } = grupos
        return pagina
      },
      set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'grupos',
          value: value
        })
      }
    },
    nome: {
      get() {
        const { grupos } = this.$store.state.vuetableState
        const { nome } = grupos.filtros
        return nome
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'nome',
          collection: 'grupos',
          value: value
        })
        this.resetPageStore()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/materiais-padronizados/grupo/index.vue